module.exports = __webpack_public_path__ + "static/img/banner01.e8f3045e.png";